const masterTemplateStatic = {
  userError: 'Master template not found, please contact support',
  templateTypes: [
    {
      id: 2,
      name: 'Standard',
      templateBaseName: 'expert_master_template',
      default: true
    },
    {
      id: 1,
      name: 'Simple',
      // templateBaseName: 'expert_master_template_simple'
      templateBaseName: 'expert_master_template_testing',
      default: false
    }
  ]
}

module.exports = {
   masterTemplateStatic
}